// src/app/providers/QueryProvider.tsx
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'; // Optional devtools

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Default options for all queries
          //staleTime: 1000 * 60 * 5, // Data is considered fresh for 5 minutes
          refetchOnWindowFocus: false, // Don't refetch on window focus by default
    },
  },
});

type QueryProviderProps = {
  children: React.ReactNode;
};

function QueryProvider({ children }: QueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* Optional: React Query Devtools for easier debugging in development */}
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}

export default QueryProvider;